import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase/config';
import { FaEdit } from 'react-icons/fa';
import HRPoliciesEditModal from './components/HRPoliciesEditModal';
import './HRPolicies.scss';

const HRPolicies = () => {
  const [policyContent, setPolicyContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  
  const { user } = useSelector(state => state.auth);
  const isAdmin = user?.userType === "admin";

  useEffect(() => {
    fetchPolicyContent();
  }, []);

  const fetchPolicyContent = async () => {
    try {
      setLoading(true);
      const docRef = doc(db, 'authUsers', 'webPages');
      const docSnap = await getDoc(docRef);
      
      if (docSnap.exists()) {
        const data = docSnap.data();
        setPolicyContent(data.hrPolicyPage || '');
      } else {
        setError('HR policy content not found.');
      }
      
      setLoading(false);
    } catch (err) {
      console.error('Error fetching HR policy content:', err);
      setError('Failed to load HR policy content. Please try again later.');
      setLoading(false);
    }
  };

  const handleUpdateContent = (newContent) => {
    setPolicyContent(newContent);
    setShowEditModal(false);
  };

  return (
    <div className="hr-policies-container">
      <div className="page-header">
        <div className="header-content">
          <h1>HR Policies {isAdmin && '(Admin Only)'}</h1>
          <p>Important company policies and guidelines</p>
        </div>
        
        {isAdmin && (
          <button 
            className="edit-policy-btn" 
            onClick={() => setShowEditModal(true)}
          >
            <FaEdit /> Edit Policies
          </button>
        )}
      </div>

      {loading ? (
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Loading policies...</p>
        </div>
      ) : error ? (
        <div className="error-message">
          <p>{error}</p>
        </div>
      ) : (
        <div className="policies-content">
          {policyContent ? (
            <div 
              className="policy-html-content" 
              dangerouslySetInnerHTML={{ __html: policyContent }}
            />
          ) : (
            <div className="no-policy-content">
              <p>No HR policy content available. {isAdmin && 'Click the Edit button to add content.'}</p>
            </div>
          )}
        </div>
      )}

      {showEditModal && (
        <HRPoliciesEditModal 
          initialContent={policyContent}
          onClose={() => setShowEditModal(false)}
          onSave={handleUpdateContent}
        />
      )}
    </div>
  );
};

export default HRPolicies; 